import { Divider, DividerProps } from "@mui/material";
import { ReactElement } from "react";
import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui } from "@ryde/theme";

export const FilterActionsStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "filter-actions",
})`
  display: flex;
  align-items: center;
`;

export const FilterActionsDividerStyled = (
  props: DividerProps,
): ReactElement => (
  <Divider
    variant="middle"
    orientation="vertical"
    sx={{
      borderStyle: "dashed",
      borderColor: greyMui._400,
      marginInline: "5px",
    }}
    flexItem
    {...props}
  />
);
